import { render, staticRenderFns } from "./EducationalGroupTransferFilter.vue?vue&type=template&id=9bfb630a&"
import script from "./EducationalGroupTransferFilter.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTransferFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports